import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import './css/styles.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(

        <BrowserRouter>
             <App />
        </BrowserRouter>
       

)